import http from "../../core/services/http.service";

export default {
  getFeatureRequests(params = null, expand) {
    return http.get(`/api/v1/feature-requests/?expand=${expand}`, {params});
  },
  getFeatureRequest(id, expand, params = {}) {
    return http.get(`/api/v1/feature-requests/${id}/?expand=${expand}`, {params});
  },
  updateFeatureRequest(id, data, expand = '') {
    return http.put(`/api/v1/feature-requests/${id}/?expand=${expand}`, data);
  },
  createFeatureRequest(data, expand = '') {
    return http.post(`/api/v1/feature-requests/?expand=${expand}`, data);
  },
  removeFeatureRequest(uuid) {
    return http.delete(`/api/v1/feature-requests/${uuid}/`)
  },
  getFeatureRequestComments(params = null, expand) {
    return http.get(`/api/v1/feature-requests/comments/?expand=${expand}`, {params});
  },
  createFeatureRequestComment(data, expand = '') {
    return http.post(`/api/v1/feature-requests/comments/?expand=${expand}`, data);
  },
  pay(data) {
    return http.post(`/api/v1/feature-requests/pay/`, data)
  },
  getInvoicePdfData(featureRequestUuid) {
    return http.get(`/api/v1/feature-requests/${featureRequestUuid}/pdf-data/`);
  },
};
